"use client";

import React from "react";

export function Gallery10() {
  return (
    /* bg-wood-light = světle šedá, font-sans = Inter */
    <section className="bg-wood-light text-black font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        
        {/* Nadpis sekce - Gelasio */}
        <div className="mb-12 text-center md:mb-18 lg:mb-20">
          <h2 className="text-[32px] font-bold font-serif leading-[1.2] md:text-[48px] lg:text-[56px]">
          Roubené stavby na klíč
          </h2>
        </div>

        {/* Masonry layout pro přesně 7 fotek (2-3-2) */}
        <div className="gap-4 space-y-4 md:columns-2 lg:columns-3 md:gap-6 md:space-y-6">
          
          {/* LEVÝ SLOUPEC (ve výsledku se to poskládá samo podle výšky) */}
          <div className="break-inside-avoid overflow-hidden rounded-sm">
            <img src="img/Placeholder Image 12png.png" className="w-full object-cover" alt="1" />
          </div>
          <div className="break-inside-avoid overflow-hidden rounded-sm">
            <img src="img/Placeholder Image 22.png" className="w-full object-cover" alt="2" />
          </div>

          {/* PROSTŘEDNÍ SLOUPEC */}
          <div className="break-inside-avoid overflow-hidden rounded-sm">
            <img src="img/Placeholder Image 32.png" className="w-full object-cover" alt="3" />
          </div>
          <div className="break-inside-avoid overflow-hidden rounded-sm">
            <img src="img/Placeholder Image 42.png" className="w-full object-cover" alt="4" />
          </div>
          <div className="break-inside-avoid overflow-hidden rounded-sm">
            <img src="img/Placeholder Image 52.png" className="w-full object-cover" alt="5" />
          </div>

          {/* PRAVÝ SLOUPEC */}
          <div className="break-inside-avoid overflow-hidden rounded-sm">
            <img src="img/Placeholder Image 62.png" className="w-full object-cover" alt="6" />
          </div>
          <div className="break-inside-avoid overflow-hidden rounded-sm">
            <img src="img/Placeholder Image 72.png" className="w-full object-cover" alt="7" />
          </div>

        </div>
      </div>
    </section>
  );
}